interface IDateTime {
  date: string;
  offset: number;
  time: string;
}

export default class DateUtils {
  static convertMinutesToMiliseconds = (minutes: number): number => minutes * 60 * 1000;

  static getFormattedDateFromString = (date: string, locale: string) : string => {
    return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long' }).format(new Date(date));
  };

  static getFormattedDate = (date: Date, locale: string) : string => {
    return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long' }).format(date);
  };

  static getFormatDateLocalString = (dateString: string, locale:string) :string => {
    const date = new Date(dateString);
    const datePart = date.toLocaleDateString(locale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
    const weekday = date.toLocaleDateString(locale, { weekday: 'long' });

    return `${datePart} ${weekday}`;
  };

  static isValidDeliveryDate = (date : string) : boolean => {
    return date && /^\d{4}-\d{2}-\d{2}$/.test(date.trim());
  };

  static isValidDeliveryTime = ( time: string) : boolean => {
    return time && /^\d{1,2}:\d{2}\s*-\s*\d{1,2}:\d{2}$/.test(time.trim());
  };

  static getDateFromTimeZone = (timeZone: string): Date => (
    new Date(new Date().toLocaleString('en-US', { timeZone }))
  );

  static getOffsetDate = (dateTime: IDateTime): Date => {
    const { date, offset, time } = dateTime;
    const adjustedTime = `${Array(4).join('0')}${Number(time)}`.slice(-4);

    // Convert military time number to military string, ie: from 945 to '09:45'
    const formattedTime = `${adjustedTime.substring(0, 2)}:${adjustedTime.substring(adjustedTime.length - 2)}`;

    return new Date(`${date} ${formattedTime} ${offset}`);
  };

  static fromMilitaryToStandardTime = (militaryTimeNumber: number): string => {
    const timeMoment = militaryTimeNumber >= 1200 ? 'pm' : 'am';
    let timeNumber = militaryTimeNumber;

    let formattedTime;

    if (militaryTimeNumber > 1259) {
      timeNumber -= 1200;
    }

    if (militaryTimeNumber === 0) {
      return `12${timeMoment}`;
    }

    const cutOff = timeNumber < 1000 ? 1 : 2;
    const timeHours = timeNumber.toString().slice(0, cutOff);
    const timeMinutes = timeNumber.toString().slice(cutOff);

    if (timeMinutes !== '00') {
      formattedTime = `${timeHours}:${timeMinutes}${timeMoment}`;
    } else {
      formattedTime = `${timeHours}${timeMoment}`;
    }

    return formattedTime;
  };

  static getCurrentTimeInMilitary = (dateTime: Date): number => {
    const hours = dateTime.getHours().toString();
    const minutes = dateTime.getMinutes().toString().padStart(2, '0');
    return +(hours + minutes);
  };

  static convertDateToIsoString = (dateTime: Date): string => {
    let isoTime;
    try {
      isoTime = dateTime.toISOString();
    } catch {
      isoTime = '';
    }
    return isoTime;
  };

  static isRawTimeValid = (time: number): boolean => {
    return time >= 0 && time <= 2400;
  };
}
